import React from 'react';
import { Link } from 'react-router-dom';
import './MiniFooter.css';

const LINKS = [
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact Us' },
  { to: '/return-policy', label: 'Return Policy' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/payment-methods', label: 'Payment Methods' },
];

/**
 * Compact trust/policy links for pages that do not use the full site {@link Footer}.
 */
const MiniFooter = () => (
  <footer className="mini-footer" role="contentinfo">
    <div className="mini-footer__inner">
      <nav className="mini-footer__nav" aria-label="Policies and contact">
        {LINKS.map(({ to, label }, i) => (
          <React.Fragment key={to}>
            {i > 0 && <span className="mini-footer__sep" aria-hidden />}
            <Link className="mini-footer__link" to={to}>
              {label}
            </Link>
          </React.Fragment>
        ))}
      </nav>
    </div>
  </footer>
);

export default MiniFooter;
